module.exports = __webpack_public_path__ + "static/media/badger.13b0a661.png";